import React, { useState, useMemo } from 'react'
import { Box, CircularProgress, Alert } from '@mui/material'
import { Section, ReportTable, SubTabs, Pill } from '../../report-shell'

const OrangeOpaskaKAMHistory = ({ data, loading, error }) => {
  const [kamTab, setKamTab] = useState(0)
  const kams = data?.kams || []
  const month_keys = data?.month_keys || []

  const columns = useMemo(() => {
    const cols = [
      { field: 'salon_name', header: 'Salon', width: '1.4fr', minWidth: 180 },
      { field: 'name2', header: 'Nazwa dod.', width: '140px' },
      { field: 'city', header: 'Miasto', width: '120px' },
    ]
    for (const mk of month_keys) {
      cols.push({
        field: `__month_${mk.key}`,
        header: mk.label,
        width: '90px',
        sales: true,
        // Pull value from row.months[mk.key]; ReportTable doesn't have valueGetter
        // so we compute it via render and sort by extracting via accessor in row pre-process.
        render: (_v, row) => {
          const v = row.months?.[mk.key] || 0
          if (!v) return <span style={{ color: 'rgba(0,0,0,0.4)' }}>0</span>
          return <span style={{ color: '#16a34a', fontWeight: 600 }}>{v}</span>
        },
      })
    }
    return cols
  }, [month_keys])

  const currentKam = kams[kamTab]
  const rows = useMemo(() => {
    if (!currentKam) return []
    return currentKam.salon_history.map((s, i) => {
      // Flatten months into top-level fields so sorting works
      const flat = { id: s.salon_name || i, ...s }
      for (const mk of month_keys) {
        flat[`__month_${mk.key}`] = s.months?.[mk.key] || 0
      }
      return flat
    })
  }, [currentKam, month_keys])

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (error) return <Alert severity="error">{error}</Alert>
  if (!data || kams.length === 0) {
    return <Alert severity="info">Brak danych historii KAM</Alert>
  }

  const tabsItems = kams.map((k, i) => ({
    value: i,
    label: `${k.kam_name} (${k.current_month_count})`,
  }))

  return (
    <Section
      title="Historia sprzedaży per KAM"
      subtitle={currentKam ? `${currentKam.kam_name} — ${currentKam.opaski_per_salon}/salon · ${currentKam.salon_count} salonów` : null}
      right={<SubTabs tabs={tabsItems} value={kamTab} onChange={setKamTab} />}
    >
      {currentKam && currentKam.opaski_per_salon_history?.length > 0 && (
        <div style={{
          display: 'flex', gap: 6, padding: '12px 16px', flexWrap: 'wrap',
          borderBottom: '1px solid rgba(0,0,0,0.08)',
          background: '#fafaf9',
        }}>
          <Pill kind="info">Bieżący: {currentKam.opaski_per_salon}/salon</Pill>
          {currentKam.opaski_per_salon_history.slice(0, 6).map((h) => (
            <Pill key={h.month} kind="neutral">{h.label}: {h.ratio}/salon</Pill>
          ))}
        </div>
      )}
      {currentKam && (
        <ReportTable
          rows={rows}
          columns={columns}
          initialSort={month_keys.length > 0 ? { field: `__month_${month_keys[0].key}`, dir: 'desc' } : null}
          pageSize={25}
          pageSizeOptions={[25, 50, 100]}
          density="compact"
        />
      )}
    </Section>
  )
}

export default OrangeOpaskaKAMHistory
